import { BaseApiClient } from "../base-api-client";
export class CopyTradeClient extends BaseApiClient {
    constructor(config) {
        super({ ...config, baseURL: `${config.baseURL}/copy-trade` }, "CopyTradeClient");
    }
    async listLeaders(source = "binance") {
        const response = await this.get(`/leaders?source=${source}`);
        if (!response.success) {
            throw new Error(response.error || "Failed to list copy trade leaders");
        }
        return response.data ?? [];
    }
    async getLeaderDetail(portfolioId, source = "binance") {
        const response = await this.get(`/leaders/${portfolioId}/detail?source=${source}`);
        if (!response.success || !response.data) {
            throw new Error(response.error || "Failed to fetch leader detail");
        }
        return response.data;
    }
    async getLeaderPositions(portfolioId, source = "binance") {
        const response = await this.get(`/leaders/${portfolioId}/positions?source=${source}`);
        if (!response.success || !response.data) {
            throw new Error(response.error || "Failed to fetch leader positions");
        }
        return response.data;
    }
    async listSubscriptions(userId) {
        const response = await this.get(`/subscriptions/user/${userId}`);
        if (!response.success) {
            throw new Error(response.error || "Failed to list copy trade subscriptions");
        }
        return response.data ?? [];
    }
    async listMirroredPositions(subscriptionId, userId) {
        const response = await this.get(`/subscriptions/${subscriptionId}/user/${userId}/positions`);
        if (!response.success) {
            throw new Error(response.error || "Failed to list mirrored copy trade positions");
        }
        return response.data ?? [];
    }
    async subscribe(userId, payload) {
        const response = await this.post(`/subscriptions/user/${userId}`, payload);
        if (!response.success || !response.data) {
            throw new Error(response.error || "Failed to subscribe to copy trade leader");
        }
        return response.data;
    }
    async updateSubscription(subscriptionId, userId, payload) {
        const response = await this.patch(`/subscriptions/${subscriptionId}/user/${userId}`, payload);
        if (!response.success || !response.data) {
            throw new Error(response.error || "Failed to update copy trade subscription");
        }
        return response.data;
    }
    async unsubscribe(subscriptionId, userId) {
        await this.delete(`/subscriptions/${subscriptionId}/user/${userId}`);
    }
}
//# sourceMappingURL=copy-trade-client.js.map